import { Outlet } from "react-router-dom";
import { HeaderBar } from "../Header";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Footer } from "../Footer";

export const LayoutNotAuth: React.FC<{}> = () => {
    const theme = useTheme();
    const isXSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

    const getMinHeight = () => {
        if (isXSmallScreen) {
            return '50vh';
        } else if (isSmallScreen) {
            return '60vh';
        } else if (isMediumScreen) {
            return '80vh';
        }
        else {
            return '90vh';
        }
    };

    const minHeight = getMinHeight();

    return (
        <>
            <HeaderBar />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: minHeight,
                }}
            >
                <Box component="main" sx={{ mt: 0, pt: 0 }}>
                    <Outlet />
                </Box>
                <Footer />
            </Box>
        </>
    );
}